import { ClipboardCheck, BookOpen, ListChecks, Sparkles, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const stepKeys = ['free_analysis', 'onboarding', 'execution', 'what_works'] as const;
const stepIcons = [ClipboardCheck, BookOpen, ListChecks, Sparkles];

const ProcessSection = () => {
  const { t } = useTranslation();

  return (
    <section id="process" className="py-24 md:py-32 bg-[#ece8e1]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 border border-gray-300 rounded-full px-5 py-2 mb-6">
            <Sparkles className="w-4 h-4" />
            {t('simonsMarketing.process.badge')}
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-gray-900">
            {t('simonsMarketing.process.title')} <em className="font-serif">{t('simonsMarketing.process.title_italic')}</em>
          </h2>
        </div>

        <div className="flex flex-col gap-5">
          {stepKeys.map((key, index) => {
            const Icon = stepIcons[index];
            const number = String(index + 1).padStart(2, '0');
            return (
              <div
                key={key}
                className="bg-white rounded-2xl px-6 py-5 flex items-center gap-5 shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-gray-700" />
                </div>
                <div className="flex items-baseline gap-3 flex-wrap">
                  <span className="text-base font-bold text-gray-900 whitespace-nowrap">
                    {number}. {t(`simonsMarketing.process.steps.${key}.title`)}
                  </span>
                  <span className="text-gray-500 text-base">
                    {t(`simonsMarketing.process.steps.${key}.description`)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/free-analysis"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-semibold rounded-xl hover:bg-gray-800 transition-colors duration-300 text-lg shadow-sm"
          >
            {t('simonsMarketing.hero.cta_primary')}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
